import React, { FC } from 'react'

type AuthorData = {
  fullName: string
  slug: string
}

interface BlogPublisherNameInterProps {
  authorData: AuthorData
  authorClassName: string
}

const BlogPublisherName: FC<BlogPublisherNameInterProps> = ({
  authorData,
  authorClassName = ''
}) => {
  const className =
    'cursor-pointer font-semibold text-gray-1100 underline md:no-underline md:hover:underline'

  return (
    <div className={authorClassName}>
      <a
        href={`/author/${authorData.slug}/`}
        className={`${className} hidden sm:block`}
      >
        {authorData.fullName}
      </a>
      <span className={`${className} block sm:hidden`}>
        {authorData.fullName}
      </span>
    </div>
  )
}
export default BlogPublisherName
